import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
/**
 * §5's "Large, tactile grids with desaturated, high-contrast visual cues (No complex UI
 * nested drop-downs)" — the till's atomic tap target (a product tile, a payment-method
 * choice, a large "Void"/"Discount" action). Meets `FIXED_TOKENS.touchTargetMin` by
 * default via `styles.css`; do not override `min-height`/`min-width` down below that
 * floor for anything meant to be tapped at the register.
 */
export const TouchButton = forwardRef(function TouchButton({ label, sublabel, media, active = false, className, ...rest }, ref) {
    return (_jsxs("button", { ref: ref, type: "button", className: ["sl-touch-button", active ? "sl-touch-button--active" : null, className]
            .filter(Boolean)
            .join(" "), ...rest, children: [media ? _jsx("span", { className: "sl-touch-button__media", children: media }) : null, _jsx("span", { className: "sl-touch-button__label", children: label }), sublabel ? _jsx("span", { className: "sl-touch-button__sublabel", children: sublabel }) : null] }));
});
//# sourceMappingURL=TouchButton.js.map